export const style = {
  wrapper: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'center',
  },
  icons: {
    thumbsUp: {
      height: '16px',
      width: '16px',
    },
    thumbsDown: {
      height: '16px',
      width: '16px',
    },
  },
  declineIconButton: {
    sx: {
      borderRadius: '99px',
      width: '52px',
      height: '36px',
      backgroundColor: 'rgba(209, 67, 67, 0.12)',
      '&:hover': {
        backgroundColor: 'rgba(209, 67, 67, 0.24)',
      },
    },
  },
  promoteIconButton: {
    sx: {
      borderRadius: '99px',
      width: '52px',
      height: '36px',
      backgroundColor: 'rgba(16, 185, 129, 0.08)',
      '&:hover': {
        backgroundColor: 'rgba(16, 185, 129, 0.24)',
      },
    },
  },
} as const;
